// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stress-management.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stress-management/stress-management.js';

mount([g0]);
